// import { darken } from 'polished';
import styled from 'styled-components';

export const Model1 = styled.div`
    height: 100%;
    display: flex;
    background: ${props => {
        const { colors, defColors } = props;
        const c =
            colors && colors.background
                ? colors.background
                : defColors.background;
        return c;
    }};

    .img-area {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        padding-right: 0px;

        .robot-img {
            max-width: 80%;
            max-height: 60%;
        }

        .pluginspace-logo {
            max-width: 40%;
        }
    }

    .tray-row {
        height: 20%;
        width: 90%;
        display: flex;
        flex-direction: row;
        text-align: center;
        color: #000;

        .tray {
            background: #ddd;
            border-radius: 2px;
            display: flex;
            flex-direction: column;
            align-items: right;
            justify-content: center;
        }

        .clear-icon {
            display: flex;
            flex-direction: column;
            align-items: right;
            justify-content: center;
        }
    }

    .options-area {
        height: 80%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .page-img {
            max-width: 100%;
            max-height: 20%;
            object-fit: cover;
            width: ${props => {
                const parameters = (props && props.parameters) || {};
                const img_width = parameters.media_width || 0;
                const w = img_width;
                return w <= 100 ? `${w}%` : '100%';
            }};
        }

        .destinations {
            height: -webkit-fill-available;
            width: 100%;
            background: #fff;
            border-radius: 1px;

            .destination {
                width: 100%;
                background: ${props => {
                    const { colors, defColors } = props;
                    const c =
                        colors && colors.destinations
                            ? colors.destinations
                            : defColors.destinations;
                    return c;
                }};
                border-radius: 2px;
                text-align: center;
                color: ${props => {
                    const { colors, defColors } = props;
                    const c =
                        colors && colors.button_text
                            ? colors.button_text
                            : defColors.button_text;
                    return c;
                }};
            }
        }

        .go-button {
            width: 100%;
            text-align: center;
            border-radius: 2px;
            background-color: ${props => {
                const { colors, defColors } = props;
                const c =
                    colors && colors.action_button
                        ? colors.action_button
                        : defColors.action_button;
                return c;
            }};
            span {
                font-size: ${props => {
                    const h = props.dimensions.height;
                    return `${parseInt(h * 0.05, 10) || 0}px`;
                }};
            }
        }
    }
`;

export const Model2 = styled.div`
    display: flex;
    height: 100%;

    .header {
        width: 40%;
        height: 10%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: ${props => {
            const { colors } = props;
            const c1 = colors ? colors.buttons : '#000';
            return c1;
        }};

        border-bottom: 1px solid #000000aa;

        .pluginbot-logo {
            max-height: 50%;
        }
    }

    .content {
        width: 100%;
        height: 90%;
    }

    .icon-area {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        padding-right: 0px;
    }

    .img-area {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        padding-right: 0px;

        .robot-img {
            max-width: 80%;
            max-height: 60%;
        }

        .pluginspace-logo {
            max-width: 40%;
        }

        .robot-name {
            font-size: ${props => {
                const h = props.dimensions.height;
                return `${parseInt(h * 0.05, 10) || 0}px`;
            }};
        }
    }

    .options-area {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;

        .pluginspace-logo {
            max-width: 90%;
        }

        .pluginbot-logo {
            max-width: 40%;
        }

        .options {
            width: 80%;
        }

        button {
            span {
                font-size: ${props => {
                    const h = props.dimensions.height;
                    return `${parseInt(h * 0.05, 10) || 0}px`;
                }};
            }
        }
    }
`;
